import { useMemo } from 'react';

import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { User } from '../../../../../../../../../../types';

import { dateFormatter, nestedFieldValueGetter } from 'utils/grid';

import { GridColDef } from '@mui/x-data-grid-pro';

const useColumnDefinitions = (users: User[]) => {
  const { t } = useTranslation('common');

  return useMemo(() => columnDefinitions(t, users), [t]);
};

const columnDefinitions = (t: TFunction, users: User[]) => {
  if (!users) {
    return [];
  }

  const findUser = (row) =>
    users.find((user) => user.accountId === row.accountId);

  return [
    {
      field: t('api_accounts.accountName'),
      headerName: 'Account name',
      valueGetter: (params) => {
        const { row } = params;

        return findUser(row)?.accountName;
      }
    },
    {
      field: 'nameFirstNames',
      headerName: t('firstName'),
      flex: true,
      valueGetter: (params) => {
        const { row } = params;

        return findUser(row)?.nameFirstNames;
      }
    },
    {
      field: 'nameLast',
      headerName: t('lastName'),
      flex: true,
      valueGetter: (params) => {
        const { row } = params;

        return findUser(row)?.nameLast;
      }
    },
    {
      field: 'valid.from',
      type: 'date',
      headerName: t('validFrom'),
      valueGetter: nestedFieldValueGetter,
      valueFormatter: dateFormatter,
      flex: 1,
      minWidth: 120
    },
    {
      field: 'valid.to',
      type: 'date',
      headerName: t('validTo'),
      valueGetter: nestedFieldValueGetter,
      valueFormatter: dateFormatter,
      flex: 1,
      minWidth: 120
    }
  ] as GridColDef[];
};

export default useColumnDefinitions;
